import { render } from "./cell_send_robot.vue?vue&type=template&id=2152489c"
import script from "./cell_send_robot.vue?vue&type=script&lang=ts"
export * from "./cell_send_robot.vue?vue&type=script&lang=ts"

import "./cell_send_robot.vue?vue&type=style&index=0&id=2152489c&lang=less"
script.render = render

export default script